import { isPlacesHomePage } from './isPlacesHomePage';
import { isPlacesPeopleTab } from './isPlacesPeopleTab';

// Check shouldStartDashboardPlt.Test.ts to understand the scenarios covered
export function shouldStartDashboardPlt(pathname: string): boolean {
    return isPlacesHomePage(pathname) || isPlacesPeopleTab(pathname);
}
